import { Box} from "@mui/joy";
import { Pagination, PaginationItem } from "@mui/material";


const PaginatedNumbers = ({
  totalPages,
  page,
  changePage,
  maxPageNumberLimit,
  minPageNumberLimit,
}) => {
  const pages = Array.from({ length: totalPages }, (_, index) => index);

  return (
    <Pagination
      count={totalPages}
      page={page}
      onChange={(_, value) => changePage(value)}

      variant="outlined"
      color="primary"

      renderItem={(item) =>
        item.page <= maxPageNumberLimit + 1 && item.page > minPageNumberLimit ? (
          <PaginationItem
            {...item}
            sx={{
              backgroundColor: page === item.page ? "black" : "white",
              color: page === item.page ? "red" : "black",
              border: "1px solid #ccc",
              borderRadius: "8px",
              "&:hover": { backgroundColor: "blue", color: "white" },
            }}
          />
        ) : null
      }
    />
  );
};



export default function Paginations({
  totalPages,
  page,
  changePage,
  minPageNumberLimit,
  maxPageNumberLimit,
}) {
  return (
    <Box sx={{ display: 'flex',justifyContent:'center', gap: 2 ,}}>



      <PaginatedNumbers
        totalPages={totalPages}
        changePage={changePage}
        page={page}
        minPageNumberLimit={minPageNumberLimit}
        maxPageNumberLimit={maxPageNumberLimit}
      />



    </Box>
  );
}